export function initGioiThieu() {
	const AUTOPLAY_DELAY = 5000;
	const HOVER_DELAY = 150;

	$("[data-js-target='gioithieu-accordion']").each(function () {
		const $accordion = $(this);
		const $section = $accordion.closest("section");
		const $imgList = $section.find(".img-list");
		let autoplayTimer = null;
		let hoverTimer = null;

		function activateItem($item, isInit = false) {
			const $panel = $item.find("[data-js-panel]");
			const $trigger = $item.find("[data-js-action='toggle-accordion']");

			if (!$item.length || !$panel.length || (!isInit && $item.hasClass("is-active"))) return;

			// Close all other panels, stopping any in-progress animations
			$accordion.find("[data-js-item]").not($item).each(function () {
				const $entry = $(this);
				$entry.removeClass("is-active");
				$entry.find("[data-js-action='toggle-accordion']").attr("aria-expanded", "false");
				$entry.find("[data-js-panel]").stop(true, true).slideUp(300);
			});

			// Open target panel
			$item.addClass("is-active");
			$trigger.attr("aria-expanded", "true");
			$panel.removeAttr("hidden").stop(true, true).slideDown(300);

			// Sync image
			const index = $item.data("index");
			$imgList.find(".img").removeClass("is-active");
			if (index) $imgList.find(`.img.${index}`).addClass("is-active");

			// Update CSS variables
			const color = $item.data("color");
			const icon = $item.data("icon");
			if (color) $section[0].style.setProperty("--color-code", color);
			if (icon) $section[0].style.setProperty("--icon-url", icon);
		}

		function startAutoplay() {
			stopAutoplay();
			autoplayTimer = setInterval(function () {
				const $items = $accordion.find("[data-js-item]");
				const $active = $items.filter(".is-active");
				let nextIndex = 0;
				if ($active.length) {
					const currentIndex = $items.index($active.first());
					nextIndex = (currentIndex + 1) % $items.length;
				}
				activateItem($items.eq(nextIndex));
			}, AUTOPLAY_DELAY);
		}

		function stopAutoplay() {
			if (autoplayTimer) {
				clearInterval(autoplayTimer);
				autoplayTimer = null;
			}
		}

		// Click: activate item immediately on click (especially mobile/touch)
		$accordion.on("click", "[data-js-action='toggle-accordion']", function (e) {
			e.preventDefault();
			const $item = $(this).closest("[data-js-item]");
			stopAutoplay();
			activateItem($item);
		});

		// Hover: debounce activation to prevent overlap on fast hover
		$accordion.on("mouseenter", "[data-js-item]", function () {
			const $item = $(this);
			stopAutoplay();
			clearTimeout(hoverTimer);
			hoverTimer = setTimeout(function () {
				activateItem($item);
			}, HOVER_DELAY);
		});

		$section.on("mouseleave", function () {
			clearTimeout(hoverTimer);
			startAutoplay();
		});

		// Init: activate first item and start autoplay
		const $activeItem = $accordion.find("[data-js-item].is-active").first();
		const $firstItem = $activeItem.length ? $activeItem : $accordion.find("[data-js-item]").first();
		if ($firstItem.length) activateItem($firstItem, true);
		startAutoplay();
	});
}